var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.60639 19.0314C14.529 19.0314 18.8635 12.466 18.8635 6.77428C18.8635 6.58971 18.8594 6.40104 18.8512 6.21647C19.6944 5.60668 20.4221 4.85137 21 3.98604C20.2147 4.33543 19.3809 4.56361 18.5272 4.6628C19.4261 4.12395 20.0992 3.27744 20.4217 2.2802C19.576 2.78139 18.6511 3.13494 17.6868 3.32569C17.037 2.63527 16.1779 2.17813 15.2422 2.02495C14.3066 1.87177 13.3465 2.03107 12.5105 2.47824C11.6745 2.9254 11.0091 3.63552 10.6171 4.4988C10.2252 5.36208 10.1285 6.33044 10.3421 7.25416C8.62968 7.16823 6.95444 6.72339 5.42498 5.94849C3.89552 5.17358 2.54598 4.08591 1.46385 2.75598C0.91385 3.70424 0.745549 4.82634 0.993152 5.89423C1.24075 6.96212 1.88568 7.89567 2.79686 8.50514C2.1128 8.48342 1.44373 8.29925 0.844922 7.96783V8.02116C0.844309 9.01628 1.18834 9.98092 1.81852 10.7511C2.44871 11.5212 3.32616 12.0494 4.30172 12.2458C3.66805 12.4191 3.00298 12.4444 2.35799 12.3196C2.63327 13.1754 3.16888 13.9239 3.89005 14.4607C4.61122 14.9975 5.48198 15.2957 6.3808 15.3137C4.85487 16.5124 2.9699 17.1625 1.02949 17.1594C0.685376 17.1589 0.341599 17.1378 0 17.0963C1.97125 18.3609 4.26434 19.0326 6.60639 19.0314Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.ba000dcf0d544c615af0782df3b64070.svg";
export { ForwardRef as ReactComponent };